var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationSegmentList = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@wheelroom/core");
exports.NavigationSegmentList = (props) => {
    if (!props.actions) {
        return null;
    }
    return (react_1.default.createElement(core_1.Ul, { wheel: Object.assign(Object.assign({}, props.wheel), { style: props.wheel.style.list }) }, props.actions.map((action, index) => (react_1.default.createElement(core_1.Li, { key: index, wheel: Object.assign(Object.assign({}, props.wheel), { style: props.wheel.style.item }) },
        react_1.default.createElement(core_1.Action, Object.assign({}, action, { hideHeading: props.hideActionHeading, hideIcon: props.hideActionIcon, wheel: Object.assign(Object.assign({}, props.wheel), { style: props.wheel.style.action }) })))))));
};
//# sourceMappingURL=navigation-segment-list.js.map